import { DEFAULT_TITLE, DEFAULT_DESCRIPTION, abs } from "@/lib/seo";

// Uses React 19 native document metadata hoisting (title/meta/link float to <head>).
// JSON-LD is rendered inline; Google reads it anywhere in the document.
export const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image,
  noindex = false,
  jsonLd = [],
}) => {
  const fullTitle = title ? `${title} | Zebaa` : DEFAULT_TITLE;
  const canonical = abs(path);
  const ogImage = image || abs("/og-image.jpg?v=2");
  const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Zebaa" />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {schemas.filter(Boolean).map((schema, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      ))}
    </>
  );
};
